import {applyMiddleware, compose} from 'redux';
import {createBrowserHistory} from 'history';
import {createReduxHistoryContext} from 'redux-first-history';
import {composeWithDevTools} from 'redux-devtools-extension';
import freeze from 'redux-freeze';
import thunk from 'redux-thunk';
import logger from './logger';
import api from './service/api/middleware';

const {createReduxHistory, routerMiddleware, routerReducer} =
  createReduxHistoryContext({'history': createBrowserHistory()});

// Middleware order matters. Logger should always be last
const coreMiddlewares =
  process.env.NODE_ENV !== 'production' ?
    [freeze, routerMiddleware, api, thunk, logger] :
    [api, routerMiddleware, thunk];

const generateMiddlewares = (customMiddlewares) => {
  if (customMiddlewares instanceof Array) {
    return [...customMiddlewares, ...coreMiddlewares];
  }
  return [customMiddlewares, ...coreMiddlewares];
};

const generateAppliedMiddleware = (customMiddlewares) => {
  const middlewares = generateMiddlewares(customMiddlewares);
  // apply the middleware
  let appliedMiddleware = applyMiddleware(...middlewares);

  // add the redux dev tools
  if (process.env.NODE_ENV !== 'production') {
    appliedMiddleware = composeWithDevTools(appliedMiddleware);
  } else {
    appliedMiddleware = compose(appliedMiddleware);
  }

  return appliedMiddleware;
};

export {generateAppliedMiddleware, routerReducer, createReduxHistory};
